export const meta = {
  recover_page: 'recover-page',
  main_page: 'main-page',
  offices_page: 'offices-page',
  about_page: 'about-page',
  apply_loan_page: 'apply-loan-page',
  repay_loan_page: 'repay-loan-page',
  faq_page: 'faq-page',
  contacts_page: 'contacts-page',
  registration_page: 'registration_step_1',
};
